// Misura passivamente l'altezza della keyboard nativa del sistema. Quando
// l'utente focusa un input/textarea normale (es. la nota nella tx-modal), la
// visualViewport si rimpicciolisce: salviamo il delta come `--kb-h` per farci
// dimensionare il nostro numpad alla stessa altezza.
//
// Persistito in localStorage per averla pronta anche al primo apertura del
// numpad in sessioni successive.

const STORAGE_KEY = 'gunsi_tally_kb_h'

export function setupKbMeasure() {
  const vv = window.visualViewport
  if (!vv) return

  // Restore measurement saved in past sessions
  const saved = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10)
  if (saved > 150) {
    document.documentElement.style.setProperty('--kb-h', `${saved}px`)
  }

  const onResize = () => {
    // Base = LAYOUT viewport, non window.innerHeight. Nella PWA Android la
    // finestra viene già ridimensionata dalla tastiera mentre innerHeight
    // resta l'altezza piena: usarla contava la tastiera due volte e lo sheet
    // schizzava in alto lasciando sotto un vuoto della sua stessa altezza.
    // Dove invece la tastiera si sovrappone (iOS) clientHeight non cambia e
    // il delta resta quello giusto.
    const layoutH = document.documentElement.clientHeight
    const delta = Math.round(layoutH - vv.height)
    // Offset LIVE per i BottomSheet: quando la tastiera è aperta gli sheet
    // salgono di --kb-live (0 a tastiera chiusa) — vedi .bsheet nel CSS.
    // Il tetto al 60% evita che una misura sballata mangi tutto lo schermo.
    const live = Math.max(0, Math.min(delta, Math.round(layoutH * 0.6)))
    document.documentElement.style.setProperty('--kb-live', `${live}px`)
    // Sanity check: keyboard sits between ~150px and ~70% of viewport
    if (delta > 150 && delta < layoutH * 0.7) {
      document.documentElement.style.setProperty('--kb-h', `${delta}px`)
      try { localStorage.setItem(STORAGE_KEY, String(delta)) } catch {}
    }
  }
  vv.addEventListener('resize', onResize)
}
